let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dz3p9")).then(() => parcelRequire('aCQV9'));